import { withInstall } from "../../utils/index"
import scSlider from './component/ScSlider.vue'

export const ScSlider = withInstall(scSlider)

export * from './component/type'